import React from 'react'
import styled from 'styled-components'
import {
  Modal,
  Button,
  Text,
  ModalInjectedProps,
  Flex,
  ButtonVariant,
} from '@sketch/components'
import { ReactComponent as WarningIcon } from '@sketch/icons/warning-triangle-64'

const IconWrapper = styled.div`
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};

  svg {
    width: 64px;
    height: 64px;
  }
`

const Title = styled(Text.H2).attrs({
  textStyle: 'header.secondary.C',
})`
  margin: 0 0 8px 0;
  font-size: ${({ theme }) => theme.fontSizes.F};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
`

const Description = styled(Text.P).attrs({
  textStyle: 'copy.tertiary.standard.E',
})`
  margin: 0 0 32px 0;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  max-width: 280px;
`

const ModalStyled = styled(Modal)`
  min-height: 640px;
  min-width: 640px;
`

export interface ModalConfirmationProps extends ModalInjectedProps {
  title: string
  description: string
  onConfirm: () => void
  cancelText?: string
  confirmText: string
  variant?: ButtonVariant
  icon?: React.ReactNode
  loading?: boolean
}

export const ModalConfirmation: React.FC<ModalConfirmationProps> = ({
  title,
  description,
  hideModal,
  onConfirm,
  cancelText = 'Cancel',
  confirmText,
  variant = 'negative',
  icon = <WarningIcon />,
  loading = false,
}) => {
  return (
    <ModalStyled onCancel={hideModal}>
      <Modal.Body>
        <Flex
          height={635}
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
        >
          <IconWrapper>{icon}</IconWrapper>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <ButtonContainer>
            <Button variant="secondary" onClick={hideModal} fill>
              {cancelText}
            </Button>
            <Button
              variant={variant}
              onClick={onConfirm}
              fill
              loading={loading}
            >
              {confirmText}
            </Button>
          </ButtonContainer>
        </Flex>
      </Modal.Body>
    </ModalStyled>
  )
}
